import { Spin } from "antd";
import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { DEFAULT_AUTHENTICATED_HOME } from "@/lib/routes";

/**
 * Guard for order-related settings (delivery fee), gated by `manage_orders`
 * (owners + admins have it). Mirrors RequireManageAiBot. The backend also
 * enforces this server-side; the guard avoids a dead-end 403 on direct nav.
 */
export function RequireManageOrders() {
  const { profileLoaded, canManageOrders } = useProfile();

  if (!profileLoaded) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <Spin />
      </div>
    );
  }

  if (!canManageOrders) {
    return <Navigate to={DEFAULT_AUTHENTICATED_HOME} replace />;
  }

  return <Outlet />;
}
